// @ts-nocheck
/* eslint-disable */
import { takeLatest, call, put } from 'redux-saga/effects';
import * as types from 'appRedux/actions/report';
import {
  SHOW_FULLSCREEN_LOADER,
  HIDE_FULLSCREEN_LOADER,
} from 'appRedux/actions/loader';
import { SELECT_PROJECT_BUDGET_PAGE } from 'appRedux/actions/project_budget';
import { API_URL as API_URI } from 'config/constants';
import * as services from 'utils/apiHelper';
import getQueryParams from 'utils/getQueryParams';
import { pages } from 'utils/constants';
import { successToast } from '../../utils/toastHandler';

function* getReport(action) {
  const token = localStorage.getItem('token');
  const { payload } = action;
  const query = getQueryParams(payload);
  const data = yield call(
    services.fetchGetApi,

    `${API_URI}/exports/?${query}`,

    token,
  );

  if (data) {
    yield put({
      type: types.GET_REPORT_SUCCESS,
      payload: data,
    });
  }
}

function* postReport(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;

  const data = yield call(
    services.fetchPostApi,
    `${API_URI}/exports/`,
    payload,
    token,
  );

  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    // yield put({
    //   type: types.POST_REPORT_SUCCESS,
    // });
    yield put({ type: types.CLOSE_FORM_MODAL });
    yield put({ type: types.POST_REPORT_SUCCESS, payload: data });
    yield put({ type: types.RESET_FORM_FIELD });
    yield put({
      type: SELECT_PROJECT_BUDGET_PAGE,
      payload: { page: pages.REPORTLIST },
    });
  }
}

function* updateReport(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;

  const data = yield call(
    services.fetchPutApi,
    `${API_URI}/exports/${payload.id}/`,
    payload,
    token,
  );

  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    // yield put({
    //   type: types.UPDATE_REPORT_SUCCESS,
    // });
    yield put({ type: types.CLOSE_FORM_MODAL });
    yield put({ type: types.RESET_FORM_FIELD });
    yield put({
      type: SELECT_PROJECT_BUDGET_PAGE,
      payload: { page: pages.REPORTLIST },
    });
  }
}

function* deleteReport(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;
  const data = yield call(
    services.fetchDelApi,
    `${API_URI}/exports/${payload.id}/`,
    token,
  );

  if (data) {
    let message = data?.success || 'Report deleted Successfully.';
    successToast(message);
  }

  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({ type: types.CLOSE_CONFIRMATION_MODAL });
    yield put({
      type: types.DELETE_REPORT_SUCCESS,
      payload,
    });
  } else {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({ type: types.CLOSE_CONFIRMATION_MODAL });
  }
}

function* runReport(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;

  const data = yield call(
    services.fetchPostApi,
    `${API_URI}/v1.1/report/`,
    payload,
    token,
  );
  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({
      type: types.RUN_REPORT_SUCCESS,
      payload: data,
    });
  }
}

function* runReportFilter(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;
  const data = yield call(
    services.fetchPostApi,
    `${API_URI}/v1.1/report/`,
    payload,
    token,
  );

  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({
      type: types.RUN_REPORT_FILTER_SUCCESS,
      payload: data,
    });
  }
}

function* reportWatcher() {
  yield takeLatest(types.GET_REPORT_REQUEST, getReport);
  yield takeLatest(types.POST_REPORT_REQUEST, postReport);
  yield takeLatest(types.UPDATE_REPORT_REQUEST, updateReport);
  yield takeLatest(types.DELETE_REPORT_REQUEST, deleteReport);

  yield takeLatest(types.RUN_REPORT_REQUEST, runReport);

  yield takeLatest(types.RUN_REPORT_FILTER_REQUEST, runReportFilter);
}

export default reportWatcher;
